import { createSelector } from '@ngrx/store';

import { State } from './reducer';
import { UserIdentification } from '@models/swagger';
import { selectUsersIdState } from '../selectors';

export const getData = createSelector(selectUsersIdState, (state: State) => state.data);

export const getError = createSelector(selectUsersIdState, (state: State) => state.error);

export const getLoading = createSelector(selectUsersIdState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: UserIdentification | null) => T) =>
  createSelector(selectUsersIdState, (state: State) => fn(state.data));
